import * as Turbo from "@hotwired/turbo"

Turbo.config.forms.confirm = async (message, form) => {
  if (form.matches(".registration")) {
    const data = new FormData(form)
    const count = data.getAll("registration[person_ids][]").filter(id => id != "").length

    if (count == 0) {
      return confirm(message)
    } else {
      return true
    }
  } else {
    return confirm(message)
  }
}
